import React from "react"

const ProductsPerPage = ({ data = [], texts, onChange, totalResults, curRows = 30, addDataLayer, cartId = null}) => {

    const limitOnChangeHandler = (limit) => {
        addDataLayer({
            title: "bottom pagination",
            resultLimit: `${limit}`,
            cart_ID: cartId,
        });
        onChange(limit)
    }

    const viewAllItemsHandler = (totalResults) => {
        addDataLayer({
            title: "bottom pagination",
            resultLimit: `${texts.all.toLowerCase()}`,
            cart_ID: cartId
        });
        onChange(totalResults)
    }

    return (
        <div className="products-per-page">
            <ul role="none">
                <li className="disabled" aria-hidden>{texts.view}</li>
                {
                    data.map((limit, i, arr) => {
                        if (i === 0 || totalResults > limit || (totalResults < limit && totalResults > arr[i - 1]))
                            return <li 
                                aria-disabled={curRows == limit}
                                role="button"
                                tabIndex="0"
                                aria-label={`${texts.view} ${limit} ${texts.items}`}
                                className={(curRows == limit && 'disabled')}
                                key={i} 
                                onClick={() => limitOnChangeHandler(limit)}>{limit}</li>
                    })
                }
                <li 
                    role="button"
                    tabIndex="0"
                    aria-label={`${texts.view} ${texts.all} ${texts.items}`}
                    className={(curRows == totalResults && 'disabled')}
                    onClick={() => viewAllItemsHandler(totalResults)}
                >
                    {texts.all}
                </li>
            </ul>
        </div>
    )
}

export default ProductsPerPage;